import { REQUEST_FORM } from "./action_types"

export const action_request = action => {
    return{
        type : REQUEST_FORM,
        name : action.name,
        phone : action.phone,
        email : action.email
    }
}